export default {
  lang: {
    num: 'ភាគComment',
    total: 'អត្ថបទ / សរុប',
    strip: 'អត្ថបទ',
    more: 'បន្ថែម',
    chosen: 'បាន ជ្រើស',
    cancel: 'ដោះ ជ្រើស',
    bulkOperations: 'ប្រតិបត្តិការ ថ្មី',
    import: 'នាំចូល',
  },
};
